import { useContext } from 'react';

import type { AuthContextInterface } from '../context/Auth/AuthContext';
import { AuthContext } from '../context/Auth/AuthContext';

export function useAuthContext(): AuthContextInterface {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthContext must be within FirebaseProvider');
  }

  return context;
}
